﻿import {deleteRequest, getHtmlRequest, postRequest} from "../utils/fetch";

export interface ISubscription {
	applicationId: string;
	pointOfSaleId: string;
	language: string;
	email: string;
	source: string;
	newsletter: boolean;
	personalMessage?: boolean;
}

export interface IUnSubscription {
	applicationId: string;
	pointOfSaleId: string;
	personId: string;
	newsletter: boolean;
	personalMessage?: boolean;
}

export function subscribeAsync(email: string, appId: string, posId: string, lang: string, source?: string, newsletter?: boolean, personalMessage?: boolean) {
	const subscription: ISubscription = {
		applicationId: appId,
		pointOfSaleId: posId,
		language: lang,
		email,
		source,
		newsletter,
		personalMessage
	};

	return postRequest<ISubscription, void>(window.context.ecomApiUrl + "/subscriptions/subscribe", subscription, { headers: new Headers({ 'Content-type': 'application/json; charset=utf-8' }) }).then(res => {
		// 
	}) as Promise<void>;
}

export function unSubscribeAsync(personId: string, appId: string, posId: string, newsletter?: boolean, personalMessage?: boolean) {
	const unSubscription: IUnSubscription = {
		applicationId: appId,
		pointOfSaleId: posId,
		personId: personId,
		newsletter,
		personalMessage
	};

	return deleteRequest<IUnSubscription, void>(window.context.ecomApiUrl + "/subscriptions/unsubscribe", unSubscription, { headers: new Headers({ 'Content-type': 'application/json; charset=utf-8' }) }).then(res => {
		// 
	}) as Promise<void>;
}

export interface IGetPersonAsyncResponse {
	readonly GetPersonForEmailResult: string;
}

export function getPersonIdAsync(email: string, posId: string): Promise<string> {
	const personIdRequest = {
		email: email,
		pointOfSaleId: posId
	};
	return postRequest<{ email, pointOfSaleId }, IGetPersonAsyncResponse>(window.context.ecomApiUrl + "/subscriptions/GetPersonForEmail", personIdRequest, { headers: new Headers({ 'Content-type': 'application/json; charset=utf-8' }) }).then(res => {
		return res;
	}) as Promise<string>;
}

export enum Gender {
	Undefined = 0,
	Male = 1,
	Female = 2,
	Neutral = 3
}

export interface IAccount {
	firstName: string;
	lastName: string;
	email: string;
	gender: Gender;
	dateOfBirth: Date | null;
	mobileNumber: string;
	personalNumber?: string;
}

export enum UpdateAccountResult {
	success = 0,
	duplicateEmail = 1,
	duplicateEmailInOtherDomain = 2
}

export function updateAccountAsync(pointOfSaleId: string, account: IAccount): Promise<IUpdateAccountResponse> {
	const args = {
		pointOfSaleId,
		account: account
	};
	return postRequest<{ pointOfSaleId, account }, IUpdateAccountResponse>('/apicore/myaccount/updateaccount', args, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
}

export interface IMailInOtherDomainError {
	readonly urlWithLink: string,
	readonly accountEmail: string
}

export interface ISetPasswordResponse {
	readonly status: ChangePasswordStatus,
	readonly label: string
}

export interface IUpdateAccountResponse {
	readonly status: UpdateAccountResult,
	readonly label: string
}

export function getDuplicateMailInOtherDomainError(accountEmail: string, pointOfSaleId: string): Promise<IMailInOtherDomainError> {
	const args = {
		accountEmail,
		pointOfSaleId
	};

	return postRequest<{ accountEmail, pointOfSaleId }, IMailInOtherDomainError>('apicore/myaccount/getduplicatemailinotherdomainerror', args, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
}

export enum ChangePasswordStatus {
	OK = 0,
	InvalidFormat,
	EqualToOld,
	InvalidOld,
	InvalidNew,
	WeakPassword,
	Error
}
export function setPasswordAsync(oldPassword: string, newPassword: string, pointOfSaleId: string): Promise<ISetPasswordResponse> {
	const args = { oldPassword, newPassword, pointOfSaleId };
	return postRequest('/apicore/myaccount/SetPassword', args, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
}

export function getAddressTiles(currentpage: string): Promise<string> {
	return getHtmlRequest(`/apicore/myaccount/getaddresstiles?currentpage=${currentpage}`, { cache: "no-cache" });
}

export enum OkResult {
	OK = 0
}

export function setAccountPreferencesAsync(configKey: string, value: boolean): Promise<OkResult> {
	const args = {
		pointOfSaleId: window.context.pointOfSaleId,
		configKey,
		value: value.toString()
	};

	return postRequest('/apicore/myaccount/setaccountpreferences', args, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
}

export function setImageEnhancementAsync(enable: boolean): Promise<OkResult> {
	const args = {
		enable
	};

	return postRequest('/apicore/myaccount/toggleimageenhancement', args, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
}

export interface IGdprAccountResult {
	success: boolean;
	info: string;
}

export function actionByMethodOnAccountAsync(method: string, password: string): Promise<IGdprAccountResult> {
	const args = {
		password
	};

	return postRequest('/apicore/myaccount/' + method, args, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
}

export interface IGdprDownload {
	gdprDownloadLink: string;
}

export function canDownloadGdprDataAsync(): Promise<IGdprDownload> {
	const args = {};

	return postRequest('/apicore/myaccount/CanDownloadGdprData', args, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
}

export interface ICheckAccountValidityResponse {
	readonly isValid: boolean;
}

export function checkAccountValidityAsync(oldAccountId: string, newAccountId: string): Promise<ICheckAccountValidityResponse> {
	const args = {
		oldAccountId,
		newAccountId
	};

	return postRequest('/apicore/myaccount/CheckAccountValidity', args, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
}
